<template>
  <div class="export-cv-modal">
    <v-layout justify-center>
      <v-dialog v-model="showExport" max-width="700">
        <v-card color="#FFF">
          <v-layout>
            <div class="card__body">
              <div class="card-header">Select format</div>
              <div class="card-body">
                <div class="card-widget">
                  <input
                    class="check-input"
                    name="download-type"
                    type="radio"
                    value="json"
                    id="json"
                    v-model="download_type"
                  />
                  <img for="json" src="@/assets/images/icons/json.svg" alt />
                  <label for="json">Json/Data</label>
                </div>
                <div class="card-widget">
                  <input
                    class="check-input"
                    name="download-type"
                    type="radio"
                    value="docx"
                    id="word"
                    v-model="download_type"
                  />
                  <img for="word" src="@/assets/images/icons/word.svg" alt />
                  <label for="word">Word</label>
                </div>
              </div>
              <div class="card-options">
                <consultfied-button
                  class="btn-save"
                  :loading="is_loading"
                  @click="exportCV()"
                >Download</consultfied-button>
              </div>
            </div>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
export default {
  name: "export-cv",
  components: {
    consultfiedButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    names: {
      type: String,
      default: "file",
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data: () => {
    return {
      show: true,
      showExport: false,
      download_type: "docx",
      temp_name: "template1.docx",
      is_loading: false,
    };
  },
  watch: {
    visible: function (val) {
      this.showExport = val;
    },
  },
  mounted() {
    this.showExport = this.visible;
  },
  methods: {
    exportCV() {
      this.is_loading = true;
      if (this.download_type == "docx") {
        this.$store
          .dispatch("EXPORT_CONSULTANT_CV", {
            id: this.id,
            type: this.download_type,
            names: this.names + " CV",
            template: this.temp_name,
          })
          .then((responce) => {
            this.is_loading = false;
          })
          .catch((error) => {
            this.is_loading = false;
          });
      } else {
        this.$store
          .dispatch("EXPORT_CONSULTANT_CV", {
            id: this.id,
            type: this.download_type,
            names: this.names + " CV",
          })
          .then((responce) => {
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      }
    },
    onClose() {
      let vm = this;
      this.$emit("onClose", null);
    },
  },
};
</script>
<style lang="scss">
.card__body {
  z-index: 9999;
  width: 100%;
  .card-header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    font-size: 18px;
    font-weight: 800;
  }
  .card-body {
    display: flex;
    justify-content: space-around;
    .card-widget {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 15px;
      border: 1px solid #ddd;
      .check-input {
        position: absolute;
        right: -5px;
        top: -4px;
      }
    }
  }
  .card-options {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn-save {
      background: #1ba5a4;
      color: #fff;
      font-size: 14px;
      font-weight: normal;
      cursor: pointer;
      border-radius: 5px;
      height: 40px;
      width: 100px;
      padding: 3px 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      &:disabled {
        background: #8d8d8d;
        opacity: 0.3;
      }
    }
  }
}
</style>
